
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ActionDefinition } from '../backend/backendapi';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { paginationOptions, searchOptions } from '../../util/vue-good-table';
import CenterOnParent from '../util/CenterOnParent';
import DefinitionDeleteModal from './Configure/DefinitionDeleteModal';
import DefinitionEditModal from './Configure/DefinitionEditModal';
import ActionDefinitionStore from '../../stores/ActionDefinitionStore';
import Toasted from 'vue-toasted';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    CenterOnParent,
    DefinitionDeleteModal,
    DefinitionEditModal,
    VueGoodTable,
  },
})
export default class Configure extends Vue {
  private readonly store = new ActionDefinitionStore();

  get columnsConfig(): any[] {
    return [{
      label: this.$t('actions.actionDefinition.model.name').toString(),
      field: (e: ActionDefinition) => e.name,
    }, {
      label: this.$t('actions.actionDefinition.model.description').toString(),
      field: (e: ActionDefinition) => e.description,
    }, {
      label: this.$t('actions.actionDefinition.model.type').toString(),
      field: (e: ActionDefinition) => this.$t('actions.actionDefinition.model.types.' + e.type).toString(),
    }, {
      label: this.$t('actions.list.actions').toString(),
      field: 'actions',
      width: '5em',
    }];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  async mounted(): Promise<void> {
    await this.store.reload();
  }

  deleteDefinition(definition: ActionDefinition): void {
    (this.$refs.deleteModal as DefinitionDeleteModal).open([this.store.definitionsById.get(definition.id)!]);
  }

  editDefinition(definition: ActionDefinition): void {
    (this.$refs.editModal as DefinitionEditModal).open(this.store.definitionsById.get(definition.id)!, false);
  }

  newDefinition(): void {
    (this.$refs.editModal as DefinitionEditModal).open(ActionDefinition.fromJS({}), true);
  }
}
